import React from 'react';
import PropTypes from 'prop-types';
import { findDOMNode } from 'react-dom';

import cls from 'classnames/bind';

import { withLayoutContext } from '@ott/layout-context';
import {
  GeoAutocompleteExtendable,
  locators as geoAutocompleteLocators,
} from '@ott/geo-autocomplete';

import get from 'lodash/get';
import scrollIntoView from 'scroll-into-view';

import s from './ToursGeoAutocomplete.scss';

const cx = cls.bind(s);

@withLayoutContext
class ToursGeoAutocomplete extends GeoAutocompleteExtendable {
  static propTypes = {
    ...GeoAutocompleteExtendable.propTypes,
    groupStarterKey: PropTypes.string,
    suggestType: PropTypes.string,
    scrollUpOnFocus: PropTypes.bool,
    isDeparture: PropTypes.bool,
  };

  static defaultProps = {
    ...GeoAutocompleteExtendable.defaultProps,
    isDeparture: false,
  };

  constructor(props, ctx) {
    super(props, ctx);

    this.state = {
      ...this.state,
      value: get(props, 'initialActiveItem.name') || this.state.value,
    };
  }

  // eslint-disable-next-line no-return-assign
  setGeoAutocompleteRef = (node) => (this.geoAutocompleteRef = node);

  getGeoAutocompleteRef = () => this.geoAutocompleteRef;

  handleFocus(e) {
    super.handleFocus(e);

    const { isMobile, scrollUpOnFocus } = this.props;

    if (isMobile && scrollUpOnFocus) {
      // eslint-disable-next-line react/no-find-dom-node
      const geoAutocompleteNode = findDOMNode(this.getGeoAutocompleteRef());
      scrollIntoView(geoAutocompleteNode, {
        time: 300,
        align: {
          top: 0.05,
          left: 0,
        },
      });
    }
  }

  handleSelect(item, options) {
    if (item) {
      this.setState({
        value: item.name,
      });
    }

    super.handleSelect(item, options);
  }

  componentWillReceiveProps(nextProps) {
    const prevProps = this.props;

    if (
      nextProps.initialActiveItem !== prevProps.initialActiveItem &&
      nextProps.initialActiveItem
    ) {
      const activeItem = nextProps.initialActiveItem || {};

      this.setState({
        value: activeItem.name,
        activeItem,
      });
    } else {
      const newActiveItem = this.findActiveItem(nextProps);

      this.setState(
        {
          activeItem: newActiveItem,
        },
        () => {
          // const { activeItem, triggerFocused } = this.state;
          // быстро что-то набрали и перешли на другое поле
          // if (isLoaded && !triggerFocused) {
          //   this.handleSelect(activeItem, { skipFocusNextControl: true });
          // }
        }
      );
    }
  }

  renderGroupTitle({ type, $topCountriesList }) {
    if ($topCountriesList) {
      return 'Самые популярные страны';
    }

    switch (type) {
      case 'geo':
        return 'Города';
      case 'airport':
        return 'Аэропорты';
      case 'country':
        return 'Страны';
      case 'tourism':
        return 'Туристические зоны';
      case 'hotel':
        return 'Отели';
      default:
        break;
    }

    return '';
  }

  renderOverlayAdditionalInfo() {
    const { activeItem } = this.state;
    const { isLoading } = this.props;

    if (!activeItem || isLoading) {
      return null;
    }

    if (!activeItem.meta) {
      return null;
    }

    return <div className={cx('iata')}>{activeItem.meta.iata}</div>;
  }

  getValue(value, isOpen, activeItem) {
    const { isDeparture } = this.props;

    if (!value) {
      return '';
    }

    if (isDeparture && activeItem) {
      if (activeItem) {
        return isOpen ? value : `из ${activeItem.name_rod}`;
      }

      return '';
    }

    return value;
  }

  render() {
    return <div ref={this.setGeoAutocompleteRef}>{super.render()}</div>;
  }
}

export default ToursGeoAutocomplete;

export const locators = {
  departure: geoAutocompleteLocators.from,
  destination: geoAutocompleteLocators.to,
};
